import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Is this for absolute beginners?",
    a: "Yes — this guide is built specifically for people starting from zero. We don't assume any prior knowledge of charts, terminology, or platforms. Every concept is explained before it's used.",
  },
  {
    q: "Do I need any trading experience to read this?",
    a: "None at all. If you've never opened a brokerage account or looked at a candlestick chart, you're in the right place. We start with the absolute basics and build up step by step.",
  },
  {
    q: "Does this guarantee I'll make profits?",
    a: "Absolutely not — and anyone promising that is misleading you. Trading involves real risk and losses are part of the journey. This book teaches you the foundations, frameworks, and habits you need. Outcomes depend entirely on your discipline and execution.",
  },
  {
    q: "What exactly will I learn?",
    a: "Trading fundamentals, market terminology, candlestick patterns, liquidity & volatility, entry/exit strategies, risk management, trading psychology, and the most common beginner mistakes. Each chapter includes visual examples and worksheets.",
  },
  {
    q: "What format is the ebook?",
    a: "PDF — readable on any device (phone, tablet, laptop, e-reader). You'll get instant access immediately after purchase, with lifetime updates included.",
  },
  {
    q: "Is there a refund policy?",
    a: "Yes. If the book isn't a fit, email us within 30 days for a full refund — no questions asked.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-[#070707] border-t border-white/5">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <div className="text-emerald-400 uppercase tracking-[0.3em] text-xs font-semibold font-display mb-4">
            FAQ
          </div>
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl tracking-tighter leading-[1.05]">
            Questions, answered.
          </h2>
        </motion.div>

        <Accordion
          type="single"
          collapsible
          className="w-full space-y-3"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-white/10 bg-[#0c0c0c] px-5 hover:border-emerald-500/30 transition-colors"
            >
              <AccordionTrigger className="font-display font-semibold text-white text-left text-base md:text-lg hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-sm md:text-base leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
